
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  if(window.flitsObjects.allCssJs.cartJs){
    if(Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable && window.flitsObjects.storeData.customer_id != -1){
      Flits.LoadStyleScript('cartJs',window.flitsObjects.allCssJs.cartJs.url);
    }
  }
  // Flits( window ).on("load", function() {
  //   setTimeout(function(){
  //     console.log("load")
  //     if(Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE){
  //       Flits.LoadStyleScript('wishlistJs',window.flitsObjects.allCssJs.wishlistJs.url);
  //     }
  //   }, 3000);
  // });
  Flits(document).on("Flits:Loaded",function(event){
    if(Flits.Metafields.IS_WISHLIST_PAID && Flits.Metafields.IS_WISHLIST_ENABLE){
      Flits.LoadStyleScript('wishlistJs',window.flitsObjects.allCssJs.wishlistJs.url);
    }
  });
  
  Flits(document).on('Flits:contactUS:Loaded', function(event){
    var data = event.detail;
    Flits.shopCountryName = 'Taiwan'
  });
  
  Flits(document).on('Flits:deliveryAddress:Loaded', function(event){
    Flits.extend({
      CountryProvinceSelector: function(country_domid, province_domid, options) {
      	return true;
      }
    });
  });
   
  Flits(document).on('Flits:AccountPage:Loaded', function(event){
    setTimeout(function(){
      window.PlusCheckoutAddressSelectorSetup();
      Flits.shopCountryName = 'Taiwan'
    }, 2000);
  });
  Flits(document).on('Flits:SocialLogin:Loaded', function(event){
    var data = event.detail;
    data.settings.domSelector = [['form#customer_login', !0], ['form#create_customer', !0], ['form#RegisterForm', !0], ['form[action="/account/login"]:not("#customer_login_guest")', !0], ['form[action="/account"][method="post"]', !0]];
  });

  Flits(document).on('Flits:SocialLoginAutomaticCode:Loaded', function(event){
    var data = event.detail;
    var el = data.el;
    var parent = data.parent; // parent
    var cloneNode = data.cloneNode; // cloned social login div
    var border = '<div class="social-login-title"><span>or</span> </div>';
    var login_fast_text = '<span class="flits-fast-login-text">快速登入：</span>';
    Flits(cloneNode).prepend(login_fast_text);
    Flits(cloneNode).append(border);
    parent.prepend(cloneNode);
  });
  // Flits(document).on('click', '.product-thumbnail__quickshop-button', function(event){
  //   setTimeout(function(){
  //     Flits('.modal.modal--quickshop #flits-wishlist-dom').css('display', 'flex');
  //     Flits('.modal.modal--quickshop #flits-wishlist-dom').removeAttr('id');
  //     Flits('.modal.modal--quickshop #flits-wsl-guest-modal').remove();
  //   }, 3000);
  // });
  var ajaxWishlistViewFunction = function(xhrOrFetch) {
    var url = this._url;

    // You can add your choice of URL Instead '?view=quick-view'
    (-1 !== url.indexOf("view=quickshop")) && Flits.dispatchEvent("Flits:AjaxWishlist", { 
      response: this,
      xhrOrFetch: xhrOrFetch
    })
  };
  Flits.addAjaxEvents(ajaxWishlistViewFunction);
  Flits.addFetchEvents(ajaxWishlistViewFunction);

  Flits(document).on("Flits:AjaxWishlist", function(){
    setTimeout(function(){
      var grid = Flits(".modal.modal--quickshop").find(".filts-wishlist-product-style .flits-wls-button");
        var handle = Flits(grid).attr('data-flits-product-handle');
        Flits(grid).parent().css('display','flex');
        Flits(grid).find('.flits-wls-icon-with-text-text').css('display','flex');
        Flits(grid).parent().removeAttr('id');
        Flits('.modal.modal--quickshop #flits-wsl-guest-modal').remove();

        if(Flits.isProductAddedInWishlist(handle)){ 
          Flits(grid).removeClass("flits-wls-inactive");
          Flits(grid).addClass("flits-wls-active");
          Flits(grid).find(".flits-wls-icon-with-text-text").html(Flits.t('Flits.locals.wishlisted_product_page.remove_from_wishlist_button', 'Remove from Wishlist'));
        }
    }, 2000);
  });
  Flits(document).on("focusin", '.flits-tingle-input', function(event){
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    Flits(this).focus();
  });
  Flits(document).on("focusout", '.flits-tingle-input', function(event){
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    Flits(this).focus();
  });
}(Flits));
